import React, { useEffect, useState, useRef } from 'react'
import ProductGrid from '../components/Products/ProductGrid';
import { SlidersHorizontal } from 'lucide-react';
import SortOptions from '../components/Products/SortOptions';
import { FaFilter } from 'react-icons/fa';
import FilterSidebar  from "../components/Products/FilterSidebar";
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductsByFilters } from '../../redux/slices/productsSlice';

const CollectionPage = () => {
    const {collection} = useParams();
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const {products, loading, error} = useSelector((state) => state.products);
    const queryParams = Object.fromEntries([...searchParams]);
    const sidebarRef = useRef(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [groupedProducts, setGroupedProducts] = useState({});

    useEffect(() => {
      dispatch(fetchProductsByFilters({collection, ...queryParams}));
    }, [dispatch,collection, searchParams]);

    // Group products by category and sort categories by most recent update
    useEffect(() => {
      if (products && products.length > 0) {
        // DEBUG: Check what data we have
        console.log('First product FULL DATA:', products[0]);
        console.log('First 3 products:', products.slice(0, 3).map(p => ({
          name: p.name,
          category: p.category,
          updatedAt: p.updatedAt,
          createdAt: p.createdAt,
          hasUpdatedAt: !!p.updatedAt,
          hasCreatedAt: !!p.createdAt
        })));
        
        // Find Acid Washed product
        const acidWashed = products.find(p => p.category.includes('Acid'));
        if (acidWashed) {
          console.log('Acid Washed product dates:', {
            name: acidWashed.name,
            category: acidWashed.category,
            updatedAt: acidWashed.updatedAt,
            createdAt: acidWashed.createdAt,
            updatedDate: new Date(acidWashed.updatedAt),
            createdDate: new Date(acidWashed.createdAt)
          });
        }
        
        // Group products by category
        const grouped = products.reduce((acc, product) => {
          const category = product.category || 'Uncategorized';
          if (!acc[category]) {
            acc[category] = {
              products: [],
              mostRecentUpdate: new Date(product.updatedAt || product.createdAt || 0)
            };
          }
          acc[category].products.push(product);
          
          // Track the most recent update in this category
          const productDate = new Date(product.updatedAt || product.createdAt || 0);
          if (productDate > acc[category].mostRecentUpdate) {
            acc[category].mostRecentUpdate = productDate;
          }
          
          return acc;
        }, {});
        
        // Sort categories by most recent update
        const sortedGrouped = Object.fromEntries(
          Object.entries(grouped).sort((a, b) => {
            return b[1].mostRecentUpdate - a[1].mostRecentUpdate;
          })
        );
        
        // DEBUG: Check sorted order
        console.log('Categories sorted by update:', Object.keys(sortedGrouped));
        
        setGroupedProducts(sortedGrouped);
      }
    }, [products]);

    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };

    const handleClickOutside = (e) => {
      // Close sidebar if clicked outside
      if(sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setIsSidebarOpen(false);
      }
    }

    useEffect(() => {
      // Add Event listener for clicks
      document.addEventListener("mousedown", handleClickOutside);
      // clean event listener for clicks
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
      
    }, []);

  return (
    <div className="flex flex-col lg:flex-row">
      {/* Mobile Filter button
       <button onClick={toggleSidebar} className="lg:hidden border p-2 mb-2 flex justify-center items-center">
         <SlidersHorizontal className="mr-2" /> Filters
       </button>

       Filter Sidebar */}
       {/* <div ref={sidebarRef} className={`${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} fixed inset-y-0 z-50 left-0 w-64 bg-white overflow-y-auto transition-transform duration-300 lg:static lg:translate-x-0`}>
         <FilterSidebar />
       </div> */}

      <div className="flex-grow p-4">
        {/* Collection Title */}
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-center uppercase tracking-wide mb-2">
            {collection ? collection : "All Collection"}
          </h1>
          <p className="text-center text-gray-600 text-sm">
            {products?.length || 0} {products?.length === 1 ? 'Item' : 'Items'}
          </p>
        </div>

        {/* Sort Options */}
        <div className="mb-6">
          <SortOptions className="mr-2"/> 
        </div>

        {/* Loading State */}
        {loading && (
          <div className="text-center py-12">
            <p className="text-gray-600">Loading products...</p>
          </div>
        )}

        {/* Error State */}
        {error && (
          <div className="text-center py-12">
            <p className="text-red-600">{error}</p>
          </div>
        )}

        {/* Products Grouped by Category - Sorted by most recent update */}
        {!loading && !error && Object.keys(groupedProducts).length > 0 && (
          <div className="space-y-12">
            {Object.entries(groupedProducts).map(([category, categoryData]) => (
              <div key={category} className="category-section">
                {/* Category Header */}
                <div className="mb-6 pb-3 border-b border-gray-300">
                  <h2 className="text-2xl md:text-3xl font-bold uppercase tracking-wide">
                    {category}
                  </h2>
                  <p className="text-sm text-gray-500 mt-1">
                    {categoryData.products.length} {categoryData.products.length === 1 ? 'Item' : 'Items'}
                  </p>
                </div>
                
                {/* Category Products Grid */}
                <ProductGrid 
                  products={categoryData.products} 
                  loading={false} 
                  error={null} 
                />
              </div>
            ))}
          </div>
        )}

        {/* Empty State */}
        {!loading && !error && products?.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-600 text-lg">No products found in this collection.</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default CollectionPage;
